import { createAction } from '@reduxjs/toolkit';
import { deliverableState } from 'store/states/deliverableState';
import Order from 'types/entities/Order';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const injectOrderAction = createAction(BaselineAffectationType.InjectOrder, (order: Order) => ({
  payload: { order },
}));

export default (state = deliverableState, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.InjectOrder:
      return {
        ...state,
        order: {
          ...action?.payload?.order,
        },
      };
    default:
      return state;
  }
};
